// dev - Amplify deployment
// This file is used when deploying to AWS Amplify dev environment

export const environment = {
  production: false,
  cognitoUserPoolId: 'us-east-1_LQKM6Q9Od',
  cognitoAppClientId: '7on3n0la9j8rjsovfakssulpf9',
  cognitoUserPoolDomain: 'https://mpayroll2-auth-dev.auth.us-east-1.amazoncognito.com',
  cognitoRedirectUri: 'https://dev.mpayroll.myappsoftware.com/',
  aws: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_LQKM6Q9Od',
    userPoolWebClientId: '7on3n0la9j8rjsovfakssulpf9',
    oauth: {
      domain: 'mpayroll2-auth-dev.auth.us-east-1.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://dev.mpayroll.myappsoftware.com/',
      redirectSignOut: 'https://dev.mpayroll.myappsoftware.com/',
      responseType: 'code',
      prompt: 'select_account'
    }
  },
  apiUrl: 'https://yh8sv8zb7i.execute-api.us-east-1.amazonaws.com'
}
